import React from 'react';
import { useSelector } from 'react-redux';

import ShipFromColumn from '../../../components/columns/ship-from-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ShipToColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { shipTo, shipFromName, shipFromId } = returnConfiguration || {};

  if (!shipTo) {
    return shipFromName || '';
  }

  return <ShipFromColumn shipFromId={shipFromId} shipFromNameFallback={shipFromName} />;
};

export const ShipTo = {
  getMessageDescriptor: () => messages.shipTo,
  id: 'ship-to',

  render: ({ fulfillmentId }) => {
    return <ShipToColumn fulfillmentId={fulfillmentId} />;
  },
};
